import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, HostBinding, HostListener, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'shared-modal-backdrop',
    templateUrl: './modal-backdrop.shared.component.html',
    styleUrls: ['./modal-backdrop.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalBackdropComponent implements OnInit, OnChanges {
    @Input() public isVisible: boolean = false;

    @Output() public onClick: EventEmitter<Event> = new EventEmitter();

    @HostBinding('class.is-visible') public hostVisible: boolean = this.isVisible;

    @HostListener('click', ['$event']) public hostClick($event: Event): void {
        this.onClick.emit($event);  /* Consumer <- modals */
    }

    constructor() { }

    ngOnInit(): void { }

    ngOnChanges(change: SimpleChanges): void {
        this.hostVisible = this.isVisible;
    }
}
